module.exports = __webpack_public_path__ + "static/Alexander-d3cad75962e8d864dda6fbfb3e156507.jpg";